"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _RatingPolarChart = _interopRequireDefault(require("./RatingPolarChart"));

function GroupRatingFeedback(_ref) {
  var messages = _ref.messages,
      feedbacks = _ref.feedbacks,
      group = _ref.group;
  var groupMessages = messages.filter(function (m) {
    return m.group === group && m.type === 'rating' && m.type !== null;
  });
  var groupFeedbacks = groupMessages.map(function (m) {
    return feedbacks && feedbacks[m.id];
  });
  return /*#__PURE__*/_react["default"].createElement(_RatingPolarChart["default"], {
    group: group,
    questions: groupMessages,
    feedbacks: groupFeedbacks
  });
}

GroupRatingFeedback.propTypes = {
  feedbacks: _propTypes["default"].array,
  messages: _propTypes["default"].array,
  group: _propTypes["default"].string
};
var _default = GroupRatingFeedback;
exports["default"] = _default;